import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography } from '@mui/material';

import { useGetStakeTokenBalanceQuery } from 'modules/api/actions/getStakeTokenBalance';
import { DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { mapDataToUndefinedIfSkip } from 'modules/api/utils';
import { useConnection } from 'modules/auth/hooks/useConnection';
import { DECIMAL_PLACES_SHORT, ZERO } from 'modules/common/const';
import { Guide } from 'modules/deprecatedLiquidStaking/components/Guide/Guide';
import { DeprecatedLiquidStakingRoutesConfig } from 'modules/deprecatedLiquidStaking/Routes';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { Dialog } from 'modules/dialogs/components/Dialog';
import { useTranslation } from 'modules/i18n';
import { useStakeToken } from 'modules/liquidStaking/hooks/useStakeToken';

import { translation } from './translation';
import { useStyles } from './useStyles';

export function DeprecatedDialog(): ReactElement {
  const { classes } = useStyles();
  const { t, keys } = useTranslation(translation);
  const { isOpened, onClose } = useDialog(KnownDialogs.lsDeprecatedDialog);

  const { name: token } = useStakeToken();

  const { isConnected, connectionKey } = useConnection();
  const { data: balance = ZERO } = useGetStakeTokenBalanceQuery(
    { connectionKey, poolAddress: DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS },
    {
      skip: !isConnected,
      selectFromResult: mapDataToUndefinedIfSkip,
    },
  );

  return (
    <Dialog
      open={isOpened}
      title={t(keys.title, { token }, true)}
      onClose={onClose}
    >
      <div className={classes.root}>
        <Typography variant="body1">
          {t(
            keys.balance,
            {
              token,
              amount: balance.decimalPlaces(DECIMAL_PLACES_SHORT).toFormat(),
            },
            true,
          )}
        </Typography>

        <Guide />

        <Typography variant="body1">{t(keys.note)}</Typography>

        <Button
          component={Link}
          size="large"
          to={DeprecatedLiquidStakingRoutesConfig.dashboard.generatePath()}
          onClick={onClose}
        >
          {t(keys.unstakeOldToken, { token })}
        </Button>
      </div>
    </Dialog>
  );
}
